<div class="margin-top-xl">
    <div class="container">
        @if(isLoading){
        <mat-spinner class="margin-left-half"></mat-spinner>
        }
        <div class="calculator" id="quicksight-dashboard"></div>
        @if(isError){
        <h1 i18n>Something went wrong. Please refresh page to try again.</h1>
        }
    </div>
</div>